import { render, staticRenderFns } from "./ImgUpload2.vue?vue&type=template&id=30c74976&scoped=true&slot-scope=scope&"
import script from "./ImgUpload2.vue?vue&type=script&lang=js&"
export * from "./ImgUpload2.vue?vue&type=script&lang=js&"
import style0 from "./ImgUpload2.vue?vue&type=style&index=0&id=30c74976&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c74976",
  null
  
)

export default component.exports